/**
 * Include your custom JavaScript here.
 * Ravolla: taal op IP, automatische vertaling, kleurnamen, pop-upkorting, aankondigingsbalk, promoregels, nieuwsbrief, betaaliconen,
 * carrousels op mobiel, uitklapbare footer en advertentielinks: /collections/naam?top=handle-1,handle-2.
 */
(function () {
  var COUNTRY_LOCALE = { FR: 'fr', BE: 'fr', LU: 'fr', MC: 'fr', DE: 'de', AT: 'de', CH: 'de', LI: 'de', IT: 'it', SM: 'it', ES: 'es', MX: 'es', AR: 'es', CL: 'es', CO: 'es', PE: 'es', NL: 'nl', PT: 'pt-PT', SE: 'sv', DK: 'da', FI: 'fi', GR: 'el', CY: 'el', PL: 'pl', RO: 'ro', MD: 'ro' };
  var shopify = window.Shopify || {};
  var locale = shopify.locale || 'fr';
  var stay = window.location.search.indexOf('stay=1') !== -1;

  function fromOutside() {
    return document.referrer.indexOf(window.location.hostname) === -1;
  }

  if (locale === 'fr' && shopify.country && fromOutside() && !shopify.designMode && !stay) {
    var target = COUNTRY_LOCALE[shopify.country] || 'en';
    if (target !== 'fr') {
      window.location.replace('/' + target.toLowerCase() + window.location.pathname + window.location.search + window.location.hash);
      return;
    }
  }

  var sourceLanguage = locale === 'fr' ? 'en' : 'auto';
  var translateCookie = 'googtrans=/' + sourceLanguage + '/' + locale.split('-')[0] + ';path=/';
  document.cookie = translateCookie;
  document.cookie = translateCookie + ';domain=.' + window.location.hostname.replace(/^www\./, '');

  var translateStyle = document.createElement('style');
  translateStyle.textContent = '.goog-te-banner-frame,.skiptranslate iframe,#goog-gt-tt{display:none!important}body{top:0!important}';
  document.head.appendChild(translateStyle);

  var translateHolder = document.createElement('div');
  translateHolder.id = 'ravolla-translate';
  translateHolder.style.display = 'none';
  document.body.appendChild(translateHolder);

  window.ravollaTranslateInit = function () {
    new window.google.translate.TranslateElement({ pageLanguage: sourceLanguage, autoDisplay: false }, 'ravolla-translate');
  };
  var translateScript = document.createElement('script');
  translateScript.src = 'https://translate.google.com/translate_a/element.js?cb=ravollaTranslateInit';
  document.body.appendChild(translateScript);

  function fixPopupDiscount() {
    document.querySelectorAll('[id*="vtl"], [class*="vtl"], [id*="vitals"], [class*="vitals"]').forEach(function (popup) {
      if (!popup.querySelector('input[type="email"]')) return;
      var walker = document.createTreeWalker(popup, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        var value = walker.currentNode.nodeValue;
        if (/20\s?%/.test(value)) {
          walker.currentNode.nodeValue = value.replace(/20(\s?)%/g, '10$1%');
        }
      }
    });
  }

  new MutationObserver(fixPopupDiscount).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  var COLOR_LOCALES = ['fr', 'en', 'de', 'it', 'es', 'nl', 'pt-PT', 'sv', 'da', 'fi', 'el', 'pl', 'ro'];
  var COLORS = [
    ['Noir', 'Black', 'Schwarz', 'Nero', 'Negro', 'Zwart', 'Preto', 'Svart', 'Sort', 'Musta', 'Μαύρο', 'Czarny', 'Negru'],
    ['Blanc', 'White', 'Weiß', 'Bianco', 'Blanco', 'Wit', 'Branco', 'Vit', 'Hvid', 'Valkoinen', 'Λευκό', 'Biały', 'Alb'],
    ['Bleu', 'Blue', 'Blau', 'Blu', 'Azul', 'Blauw', 'Azul', 'Blå', 'Blå', 'Sininen', 'Μπλε', 'Niebieski', 'Albastru'],
    ['Vert', 'Green', 'Grün', 'Verde', 'Verde', 'Groen', 'Verde', 'Grön', 'Grøn', 'Vihreä', 'Πράσινο', 'Zielony', 'Verde'],
    ['Rose', 'Pink', 'Rosa', 'Rosa', 'Rosa', 'Roze', 'Rosa', 'Rosa', 'Lyserød', 'Vaaleanpunainen', 'Ροζ', 'Różowy', 'Roz'],
    ['Rouge', 'Red', 'Rot', 'Rosso', 'Rojo', 'Rood', 'Vermelho', 'Röd', 'Rød', 'Punainen', 'Κόκκινο', 'Czerwony', 'Roșu'],
    ['Marron', 'Brown', 'Braun', 'Marrone', 'Marrón', 'Bruin', 'Castanho', 'Brun', 'Brun', 'Ruskea', 'Καφέ', 'Brązowy', 'Maro'],
    ['Gris', 'Grey', 'Grau', 'Grigio', 'Gris', 'Grijs', 'Cinzento', 'Grå', 'Grå', 'Harmaa', 'Γκρι', 'Szary', 'Gri'],
    ['Bleu marine', 'Navy', 'Marineblau', 'Blu navy', 'Azul marino', 'Marineblauw', 'Azul-marinho', 'Marinblå', 'Marineblå', 'Tummansininen', 'Μπλε navy', 'Granatowy', 'Bleumarin'],
    ['Kaki', 'Khaki', 'Khaki', 'Cachi', 'Caqui', 'Kaki', 'Caqui', 'Khaki', 'Khaki', 'Khaki', 'Χακί', 'Khaki', 'Kaki'],
    ['Jaune', 'Yellow', 'Gelb', 'Giallo', 'Amarillo', 'Geel', 'Amarelo', 'Gul', 'Gul', 'Keltainen', 'Κίτρινο', 'Żółty', 'Galben'],
    ['Violet', 'Purple', 'Lila', 'Viola', 'Morado', 'Paars', 'Roxo', 'Lila', 'Lilla', 'Violetti', 'Μωβ', 'Fioletowy', 'Mov'],
    ['Bleu clair', 'Light blue', 'Hellblau', 'Azzurro', 'Azul claro', 'Lichtblauw', 'Azul-claro', 'Ljusblå', 'Lyseblå', 'Vaaleansininen', 'Γαλάζιο', 'Jasnoniebieski', 'Albastru deschis'],
    ['Bleu ciel', 'Sky blue', 'Himmelblau', 'Celeste', 'Celeste', 'Hemelsblauw', 'Azul-céu', 'Himmelsblå', 'Himmelblå', 'Taivaansininen', 'Γαλάζιο', 'Błękitny', 'Bleu deschis'],
    ['Bleu foncé', 'Dark blue', 'Dunkelblau', 'Blu scuro', 'Azul oscuro', 'Donkerblauw', 'Azul-escuro', 'Mörkblå', 'Mørkeblå', 'Tummansininen', 'Σκούρο μπλε', 'Ciemnoniebieski', 'Albastru închis'],
    ['Bordeaux', 'Burgundy', 'Bordeaux', 'Bordeaux', 'Burdeos', 'Bordeaux', 'Bordô', 'Vinröd', 'Bordeaux', 'Viininpunainen', 'Μπορντό', 'Bordowy', 'Bordo'],
    ['Orange', 'Orange', 'Orange', 'Arancione', 'Naranja', 'Oranje', 'Laranja', 'Orange', 'Orange', 'Oranssi', 'Πορτοκαλί', 'Pomarańczowy', 'Portocaliu'],
    ['Beige', 'Beige', 'Beige', 'Beige', 'Beige', 'Beige', 'Bege', 'Beige', 'Beige', 'Beige', 'Μπεζ', 'Beżowy', 'Bej']
  ];
  var colorColumn = COLOR_LOCALES.indexOf(locale);
  var colorMap = {};
  COLORS.forEach(function (row) {
    colorMap[row[0].toLowerCase()] = row[colorColumn];
    colorMap[row[1].toLowerCase()] = row[colorColumn];
  });
  colorMap.gray = colorMap.grey;

  function translateColors() {
    document.querySelectorAll('.CartItem__Variant, .ProductForm__SelectedValue').forEach(function (element) {
      var text = element.textContent.trim();
      var translated = text.split(' / ').map(function (part) {
        return colorMap[part.toLowerCase()] || part;
      }).join(' / ');
      if (translated !== text) {
        element.textContent = translated;
      }
      element.classList.add('notranslate');
    });
  }

  if (colorColumn !== -1) {
    translateColors();
    new MutationObserver(translateColors).observe(document.body, { childList: true, subtree: true });
  }

  var SALE_TEXT = 'Buy 3, get an extra 20% off';

  var carouselStyle = document.createElement('style');
  carouselStyle.textContent = '@media (max-width:640px){.ProductList--carousel .Carousel__Cell{width:calc(50vw - 18px)!important;margin:0 4px!important}}';
  document.head.appendChild(carouselStyle);
  window.dispatchEvent(new Event('resize'));

  var bar = document.querySelector('.ravolla-topbar');
  if (bar) {
    var messages = ['💕 Free shipping from 2 items', '✨ ' + SALE_TEXT];
    bar.textContent = '';
    bar.style.height = '34px';
    bar.style.overflow = 'hidden';
    bar.style.padding = '0';

    var track = document.createElement('div');
    track.style.transition = 'transform .5s ease';
    messages.forEach(function (message) {
      var row = document.createElement('div');
      row.textContent = message;
      row.style.cssText = 'height:34px;display:flex;align-items:center;justify-content:center;padding:0 12px;white-space:nowrap;';
      track.appendChild(row);
    });
    bar.appendChild(track);

    var current = 0;
    setInterval(function () {
      current = (current + 1) % messages.length;
      track.style.transform = 'translateY(-' + (current * 34) + 'px)';
    }, 4000);
  }

  var isCollection = document.body.classList.contains('template-collection');
  var main = document.querySelector('main');
  if (main && isCollection) {
    var promo = document.createElement('p');
    promo.className = 'ravolla-promo';
    promo.textContent = SALE_TEXT;
    promo.style.cssText = 'margin:0;padding:12px 16px;text-align:center;font-size:14px;line-height:1.3;color:#1c1b1b;font-weight:600;';
    main.insertBefore(promo, main.firstChild);
  }

  function showProducts(grid) {
    grid.querySelectorAll('.ProductItem').forEach(function (item) {
      item.style.visibility = 'visible';
    });
    grid.querySelectorAll('img.Image--lazyLoad, img.Image--lazyLoading').forEach(function (image) {
      var source = image.getAttribute('data-src');
      if (source) {
        image.src = source.replace('{width}', '600');
      }
      image.classList.remove('Image--lazyLoad', 'Image--lazyLoading');
      image.classList.add('Image--lazyLoaded');
    });
  }

  function findCell(root, handle) {
    var links = root.querySelectorAll('a[href*="/products/' + handle + '"]');
    for (var i = 0; i < links.length; i++) {
      var path = links[i].getAttribute('href').split('?')[0].split('#')[0];
      if (path.split('/').pop() === handle) return links[i].closest('.Grid__Cell');
    }
    return null;
  }

  async function loadCellsFromOtherPages(grid, handles) {
    var found = {};
    var missing = handles.filter(function (handle) { return !findCell(grid, handle); });
    for (var page = 2; page <= 30 && missing.length; page++) {
      var response = await fetch(window.location.pathname + '?page=' + page);
      if (!response.ok) break;
      var html = new DOMParser().parseFromString(await response.text(), 'text/html');
      var otherGrid = html.querySelector('.ProductList--grid');
      if (!otherGrid || !otherGrid.querySelector('.Grid__Cell')) break;
      missing = missing.filter(function (handle) {
        var cell = findCell(otherGrid, handle);
        if (cell) found[handle] = document.importNode(cell, true);
        return !cell;
      });
    }
    return found;
  }

  async function moveProductsToTop() {
    var top = new URLSearchParams(window.location.search).get('top');
    var grid = document.querySelector('.ProductList--grid');
    if (!top || !grid || !isCollection) return;

    var handles = top.split(',').map(function (handle) { return handle.trim(); }).filter(Boolean);
    var loaded = await loadCellsFromOtherPages(grid, handles);

    handles.slice().reverse().forEach(function (handle) {
      var cell = findCell(grid, handle) || loaded[handle];
      if (cell) grid.insertBefore(cell, grid.firstChild);
    });
    showProducts(grid);
  }

  moveProductsToTop();

  var footer = document.querySelector('.Footer') || document.querySelector('footer');
  if (footer) {
    var signup = document.createElement('section');
    signup.className = 'ravolla-newsletter';
    signup.style.cssText = 'background:#f2f2f1;color:#1c1b1b;padding:36px 16px;text-align:center;';
    signup.innerHTML = '<h2 style="margin:0 0 8px;font-size:18px;letter-spacing:.1em;">JOIN OUR NEWSLETTER</h2>' +
      '<p style="margin:0 0 16px;font-size:14px;">New arrivals and offers, straight to your inbox.</p>' +
      '<form method="post" action="/contact#contact_form" accept-charset="UTF-8" style="display:flex;gap:8px;max-width:440px;margin:0 auto;">' +
      '<input type="hidden" name="form_type" value="customer">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="newsletter">' +
      '<input type="email" name="contact[email]" required placeholder="Your email" aria-label="Your email" style="flex:1;min-width:0;height:44px;padding:0 12px;border:1px solid #1c1b1b;background:#fff;font-size:16px;">' +
      '<button type="submit" style="height:44px;padding:0 18px;border:0;background:#1c1b1b;color:#fff;font-size:13px;letter-spacing:.1em;">SIGN UP</button>' +
      '</form>';
    footer.parentNode.insertBefore(signup, footer);
  }

  if (window.matchMedia('(max-width:640px)').matches) {
    document.querySelectorAll('.Footer__Block--links').forEach(function (block) {
      var title = block.querySelector('.Footer__Title');
      var list = block.querySelector('.Linklist');
      if (!title || !list) return;

      var sign = document.createElement('span');
      sign.textContent = '+';
      sign.style.cssText = 'font-size:18px;line-height:1;';
      title.style.cssText = 'display:flex;justify-content:space-between;align-items:center;cursor:pointer;margin-bottom:0;padding:12px 0;';
      title.setAttribute('role', 'button');
      title.appendChild(sign);
      list.style.display = 'none';

      title.addEventListener('click', function () {
        var closed = list.style.display === 'none';
        list.style.display = closed ? '' : 'none';
        sign.textContent = closed ? '−' : '+';
      });
    });
  }

  document.querySelectorAll('p').forEach(function (paragraph) {
    if (paragraph.textContent.indexOf('Livraison standard gratuite') !== -1) {
      paragraph.textContent = '💕 Free shipping from 2 items';
    }
    if (paragraph.textContent.indexOf('Réduction automatique') !== -1) {
      paragraph.textContent = '✨ ' + SALE_TEXT;
    }
  });

  function isKlarna(icon) {
    return (icon.getAttribute('aria-labelledby') || '').indexOf('klarna') !== -1;
  }

  document.querySelectorAll('svg[aria-labelledby="pi-klarna"]').forEach(function (icon) {
    (icon.closest('li') || icon).remove();
  });

  var footerIcons = document.querySelectorAll('.Footer svg[aria-labelledby^="pi-"], footer svg[aria-labelledby^="pi-"]');
  var productIcons = document.querySelector('.payment_icons');
  if (productIcons && footerIcons.length) {
    productIcons.textContent = '';
    productIcons.style.flexWrap = 'wrap';
    footerIcons.forEach(function (icon) {
      if (!isKlarna(icon)) productIcons.appendChild(icon.cloneNode(true));
    });
  }
})();
